import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function Newspaper({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 640 640"
      className={iconClass}
      width={width}
    >
      <path fill="currentColor" d="M224 128C206.3 128 192 142.3 192 160L192 480C192 491.7 188.9 502.6 183.4 512L496 512C522.5 512 544 490.5 544 464L544 160C544 142.3 529.7 128 512 128L224 128zM128 512C145.7 512 160 497.7 160 480L160 160C160 124.7 188.7 96 224 96L512 96C547.3 96 576 124.7 576 160L576 464C576 508.2 540.2 544 496 544L128 544C92.7 544 64 515.3 64 480L64 176C64 167.2 71.2 160 80 160C88.8 160 96 167.2 96 176L96 480C96 497.7 110.3 512 128 512zM416 240C416 231.2 423.2 224 432 224L480 224C488.8 224 496 231.2 496 240C496 248.8 488.8 256 480 256L432 256C423.2 256 416 248.8 416 240zM416 304C416 295.2 423.2 288 432 288L480 288C488.8 288 496 295.2 496 304C496 312.8 488.8 320 480 320L432 320C423.2 320 416 312.8 416 304zM240 368C240 359.2 247.2 352 256 352L480 352C488.8 352 496 359.2 496 368C496 376.8 488.8 384 480 384L256 384C247.2 384 240 376.8 240 368zM240 432C240 423.2 247.2 416 256 416L480 416C488.8 416 496 423.2 496 432C496 440.8 488.8 448 480 448L256 448C247.2 448 240 440.8 240 432zM288 288L352 288L352 224L288 224L288 288zM256 216C256 202.7 266.7 192 280 192L360 192C373.3 192 384 202.7 384 216L384 296C384 309.3 373.3 320 360 320L280 320C266.7 320 256 309.3 256 296L256 216z" />
    </svg>
  );
}
